import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "antd";
import Message from "../common/Message";
import AuthService from "../auth/AuthService";
import config from "../config";

const Auth = new AuthService();

const PaymentDiscountModal = ({
  isModalOpen,
  setIsModalOpen,
  setLessPayemntOption,
  requestDeliveryChargeDiscount,
  deliveryChargeStatus,
}) => {
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [isLoading, setIsLoading] = React.useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = async () => {
    requestDeliveryChargeDiscount(2);
    setLessPayemntOption(true);
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"Request Payment Discount"}
        // style={{
        //     top: 20,
        // }}
        // cancelButtonProps={{ style: { display: "none" } }}
        confirmLoading={isLoading}
        footer={[
          <>
            {deliveryChargeStatus == 1 ? (
              <Button
                size="large"
                // type="primary"
                // loading={isLoading}
                onClick={handleCancel}
              >
                {"Ok"}
              </Button>
            ) : (
              <>
                <Button
                  size="large"
                  // type="primary"
                  // loading={isLoading}
                  onClick={handleCancel}
                >
                  {"No"}
                </Button>
                <Button
                  type="primary"
                  size="large"
                  loading={isLoading}
                  onClick={handleOk}
                >
                  {"Yes"}
                </Button>
              </>
            )}
          </>,
        ]}
      >
        {deliveryChargeStatus == 1 ? (
          <Row gutter={[16, 4]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                First get Delivery Charge Discount Authorized then continue
              </h4>
            </Col>
          </Row>
        ) : (
          <Row gutter={[16, 4]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                Are you sure to request payment discount
              </h4>
            </Col>
          </Row>
        )}
      </Modal>
      <Message type={type} msg={loadMessage} />
    </>
  );
};

export default PaymentDiscountModal;
